import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { Box, Flex } from '@mantine/core'
import { useRouter } from 'next/router'

import { useLanguageState, useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'
import { Page } from '@flecto/ui/saas'

import styles from './styles.module.css'

export function PageProfileMobileLanguages() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_mobile' })

  const router = useRouter()

  const { currentLanguage, changeLanguage, supportedLanguages } =
    useLanguageState()

  return (
    <Page withContainer>
      <Page.Title>{t('page_languages.title')}</Page.Title>
      <Page.Back onClick={() => router.push('/profile')} />
      <Page.Content>
        <Flex mt='md' direction='column'>
          {supportedLanguages.map((l, i) => (
            <Box
              key={i}
              className={styles.menuItem}
              onClick={() => changeLanguage(l.locale)}
            >
              <Flex align='center' gap='sm'>
                <Box>{l.flag}</Box>
                <Box>{l.name}</Box>
              </Flex>
              {l.locale === currentLanguage.locale && <Icon icon={faCheck} />}
            </Box>
          ))}
        </Flex>
      </Page.Content>
    </Page>
  )
}
